<template>
    <div class="notFound_404">
    </div>
</template>

<script>
export default {
  mounted() {
     $('html').css('cssText','background:#fff!important')
    let width=$(window).width();
    let height=$(window).height();
    if(height>=700){
      $('.notFound_404').css({height:height+'px'})
    }
    window.onresize=function () {
      let width=$(window).width();
      let height=$(window).height();
      if(height>=700){
        $('.notFound_404').css({height:height+'px'})
      }
    }
  }
}
</script>

<style scoped>
  .notFound_404{
    background-image: url("/imgs/logo/notFound.png");
    background-repeat:no-repeat ;
    background-position: center center;
    background-size: 1000px;
  }
</style>